// extracted by mini-css-extract-plugin
export default {"error":"styles_error__eYgDk","formControl":"styles_formControl__1KSx7"};